import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  addCampaign,
  deleteCampaign,
  getCampaigns,
} from '../../../../../../../redux/actions/staffOnlyActions';
import {STATUS_FAILED, STATUS_SUCCEEDED} from '../../../../../../../redux/actionTypes';
import {selectCampaigns} from '../../../../../../../redux/reducers/staffOnlyReducer';
import CtaButton from '../../../../../atoms/Buttons/CTA/CtaButton';
import Checkbox from '../../../../../atoms/Checkbox/Checkbox';
import Textfield from '../../../../Textfield/Textfield';
import {StyledCampaigns, StyledChecklistArea, StyledEmbeddedMsg, StyledSlidingMsg} from './styles';
import Props from './typings';

const Campaigns = ({productSlug, productName}: Props) => {
  // Redux selectors
  const campaigns = useSelector(selectCampaigns);

  // Hooks
  const dispatch = useDispatch();

  // Variables
  const [filterValue, setFilterValue] = useState('');
  const [showEmbeddedMsg, setShowEmbeddedMsg] = useState(false);
  const [showSlidingMsg, setShowSlidingMsg] = useState(false);
  const [loading, setLoading] = useState(false);

  const onCampaignSelect = (campaignId, checked) => {
    setShowSlidingMsg(false);

    const errorCallbacks = [
      () => {
        setShowSlidingMsg(true);
      },
    ];

    if (checked) {
      dispatch(deleteCampaign(productSlug, campaignId, errorCallbacks));
    } else {
      dispatch(addCampaign(productSlug, campaignId, errorCallbacks));
    }
  };

  const getProductCampaigns = () => {
    setLoading(true);

    dispatch(getCampaigns(productSlug));
  };

  useEffect(() => {
    getProductCampaigns();
  }, []);

  useEffect(() => {
    if (campaigns?.status === STATUS_FAILED) {
      setShowEmbeddedMsg(true);
      setLoading(false);
    } else if (campaigns?.status === STATUS_SUCCEEDED) {
      setShowEmbeddedMsg(false);
      setLoading(false);
    }
  }, [campaigns.status]);

  return (
    <StyledCampaigns>
      <h4>{productName}</h4>

      <h5>Select campaigns:</h5>

      <Textfield placeholder={'Filter campaigns'} callback={setFilterValue} icon="search" />

      <StyledSlidingMsg $show={showSlidingMsg}>
        {`Operation wasn't successful. Please refresh the page to get correct data!`}
      </StyledSlidingMsg>

      {showEmbeddedMsg ? (
        <StyledEmbeddedMsg>
          <p>{`Campaigns couldn't be retrieved`}</p>

          <CtaButton onClick={getProductCampaigns} disabled={loading}>
            Try again!
          </CtaButton>
        </StyledEmbeddedMsg>
      ) : (
        campaigns?.data?.[productSlug] &&
        (campaigns?.data?.[productSlug]?.length ? (
          <StyledChecklistArea>
            {filterValue.length > 1
              ? campaigns.data[productSlug]
                  .filter((option) =>
                    option.choice_label?.toLowerCase().includes(filterValue.toLowerCase()),
                  )
                  .map((option, key) => (
                    <Checkbox
                      checked={option.value}
                      label={option.choice_label}
                      value={option.id_for_label}
                      group={'campaigns'}
                      callback={(id) => onCampaignSelect(id, option.value)}
                      style={'text'}
                      key={key}
                    />
                  ))
              : campaigns.data[productSlug].map((option, key) => (
                  <Checkbox
                    checked={option.value}
                    label={option.choice_label}
                    value={option.id_for_label}
                    group={'campaigns'}
                    callback={(id) => onCampaignSelect(id, option.value)}
                    style={'text'}
                    key={key}
                  />
                ))}
          </StyledChecklistArea>
        ) : (
          <StyledEmbeddedMsg>
            <p>There are no campaigns matching this artwork</p>
          </StyledEmbeddedMsg>
        ))
      )}
    </StyledCampaigns>
  );
};

export default Campaigns;
